import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeItemGroupsRoot } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemGroupsRoutes.ts'
import {
  routeItemsHome,
  routeItemsRoot,
} from '@/routers/routes/mainRoutes/routeServices/routeItems/itemsRoutes'
import { routeSerialNosRoot } from '@/routers/routes/mainRoutes/routeServices/routeItems/serialNoRoutes.ts'

const routeItemsModuleHome: RouteRecordRaw = {
  name: 'items-module',
  path: '',
  redirect: routeItemsHome,
}

const routeItemsModuleRoot: RouteRecordRaw = {
  children: [routeItemsModuleHome, routeItemGroupsRoot, routeItemsRoot, routeSerialNosRoot],
  path: 'items',
}

const redirectItems: RedirectRouteRelative = {
  name: routeItemsModuleHome.name,
}

export { redirectItems, routeItemsModuleHome, routeItemsModuleRoot }
